import { isNil } from "lodash";

export const applyCSSSetting = (cssVariableKeyPrefix: string, cssVariableKey: string, value: any) => {
  const style = document.documentElement.style;
  const key = `--${cssVariableKeyPrefix}${cssVariableKey}`;

  if (isNil(value)) {
    style.removeProperty(key);
  } else {
    style.setProperty(key, value);
  }
};
